import React, { Component } from "react";
import styled from "styled-components";

const ProgressMarkContainer = styled.div.attrs(({ progress, animationsDuration, timelineHeight }) => ({
    style: {
        left: `calc(${progress / animationsDuration * 100}% - 1px)`,
        height: `${timelineHeight + 35}px`
    }
}))`
        position: absolute;
        width: 2px;
        top: 5px;
        z-index: 99999;
`;

const ProgressMarkLine = styled.div`
        width: 100%;
        height: 100%;
        background-color: #11A9E2;
`;

const ProgressMarkTriangle = styled.div.attrs(({ disabled }) => ({
    style: {
        cursor: disabled ? "default" : "pointer"
    }
}))`
        transform: translateX(-9px);
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 14px solid #11A9E2;
`;

export function ProgressMark({ progress, animationsDuration, onStartPeek, peekDisabled, timelineHeight }) {
    return (
        <ProgressMarkContainer progress={progress} animationsDuration={animationsDuration} timelineHeight={timelineHeight}>
            <ProgressMarkTriangle onMouseDown={event => {
                if (!peekDisabled) {
                    onStartPeek(event);
                }
            }} disabled={peekDisabled} />
            <ProgressMarkLine />
        </ProgressMarkContainer>
    );
}
